import React from 'react'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import { Bar } from 'react-chartjs-2'
import processInstanceColumnList from './process-instance-column-list'
import Table from '../../../form/component/Table'
import { renderStateName } from '../../../process/util/names'

const COLOR_LIST = [
    'rgb(0,145,231)',
    'rgb(255,193,44)',
    'rgb(255,138,0)',
    'rgb(255,63,107)',
    'rgb(18,178,178)',
    'rgb(133,70,255)',
    'rgb(186,188,193)',
    'rgb(0,145,231)',
    'rgb(255,193,44)',
    'rgb(255,138,0)',
    'rgb(255,63,107)',
    'rgb(18,178,178)',
    'rgb(133,70,255)',
    'rgb(186,188,193)',
]


const compileBarData = (stateByLastChangedList) => {
    return {
        labels: stateByLastChangedList.map(entry => {
            return entry.weekDiff
        }),
        datasets: [{
            data: stateByLastChangedList.map(entry => {
                return entry.count
            }),
            backgroundColor: COLOR_LIST,
            hoverBackgroundColor: COLOR_LIST,
        }],
    }
}

const ProcessInstanceList = ({ processInstanceList, changeStateTableSetting, stateTableSetting, navigateToProcessInstanceDetail }) => {
    if (!processInstanceList) {
        return null
    }
    return (
        <ContentBox title="Process Instances">
            <Row>
                <Column size={12}>
                    <Table
                        rowsPerPage={0}
                        columnList={processInstanceColumnList}
                        rowList={processInstanceList}
                        changeTableSetting={changeStateTableSetting}
                        tableSetting={stateTableSetting}
                        idProperty="id"
                        onRowClick={(processInstance) => {
                            navigateToProcessInstanceDetail(processInstance.id)
                        }}
                    />
                </Column>
            </Row>
        </ContentBox>
    )
}


const StateLastChanged = ({ stateByLastChangedList, currentStateName, findProcessInstanceByWeekDiff, navigateToProcessInstanceDetail, stateTableSetting, changeStateTableSetting, processInstanceList }) => {
    if (!stateByLastChangedList || !stateByLastChangedList.length) {
        return null
    }
    const title = 'State Last Changed : ' + renderStateName(currentStateName)
    return (<div>
        <ContentBox title={title}>
            <Row>
                <Column size={12}>
                    <h3>Calendar Weeks</h3>
                    <Bar
                        getElementAtEvent={(dataset) => {
                            findProcessInstanceByWeekDiff(dataset[0]._index)
                        }}
                        options={{
                            legend: {
                                display: false,
                            },
                            scales: {
                                yAxes: [{
                                    ticks: {
                                        beginAtZero: true,
                                    },
                                }],
                            },
                        }}
                        data={compileBarData(stateByLastChangedList)}
                    />
                </Column>
            </Row>
        </ContentBox>
        <ProcessInstanceList
            processInstanceList={processInstanceList}
            changeStateTableSetting={changeStateTableSetting}
            navigateToProcessInstanceDetail={navigateToProcessInstanceDetail}
            stateTableSetting={stateTableSetting}/>
    </div>)
}

export default StateLastChanged



// WEBPACK FOOTER //
// ./src/modules/analytics/component/state-responsible/StateLastChanged.js